import { useToast } from "@vintecc/components";
import { useEffect } from "react";

export const NotificationHelper = () => {
  const toast = useToast();

  useEffect(() => {
    window.openToast = toast.openToast;
  }, [toast.openToast]);

  return null;
};
